export const AF3_HIDDEN_PATHS = ['/install', '/events/reports', '/events/workflows', '/devices/settings'];